import React, { forwardRef } from 'react';

import ErrorBoundary from 'src/app/layout/error/error-boundary';
import { useDarkMode } from 'src/app/state/dark-mode';

import { StyledPage } from './page.styles';

export enum PageVariant {
  GrayBackground = 'gray-background',
  MaxWidth = 'max-width',
  Table = 'table',
  TableMaxWidth = 'table-max-width',
}

type PageProps = {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  variant?: PageVariant;
};

export const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children, dataTestId, className, variant }, ref): JSX.Element => {
    const darkMode = useDarkMode();
    return (
      <ErrorBoundary>
        <StyledPage $darkMode={darkMode} className={className} data-testid={dataTestId} ref={ref} variant={variant}>
          {children}
        </StyledPage>
      </ErrorBoundary>
    );
  }
);

Page.displayName = 'Page';
